export class EventUploadDetails {
  day?: string;
  pictureDayStatus?: string;
  cameraUploadDetails?: Array<CameraUploadDetails>;
}

export class CameraUploadDetails {
  cameraName?: string;
  uploadStatus?: string;
  uploadedAssetCountMismatch?: boolean;
}
